module.exports = __webpack_public_path__ + "img/empty.47df8c81.png";